import _ from 'lodash';
import equal from 'is-equal';
import Immutable, { Iterable } from 'immutable';

export default class Util {

  static delete(value, path) {
    const parts = _.isString(path) ? path.split('.') : path;
    return Util.isImmutable(value) ? value.deleteIn(parts) : _.unset(value, parts);
  }

  static each(value, iteratee) {
    return Util.isImmutable(value) ? value.forEach(iteratee) : _.each(value, iteratee);
  }

  static first(value) {
    return Util.isImmutable(value) ? value.first() : _.first(value);
  }

  static get(value, path) {
    const parts = _.isString(path) ? path.split('.') : path;
    return Util.isImmutable(value) ? value.getIn(parts) : _.get(value, parts);
  }

  static has(value, path) {
    const parts = _.isString(path) ? path.split('.') : path;
    return Util.isImmutable(value) ? value.hasIn(parts) : _.has(value, parts);
  }

  static set(value, path, data) {
    const parts = _.isString(path) ? path.split('.') : path;
    return Util.isImmutable(value) ? value.setIn(parts, data) : _.set(value, parts, data);
  }

  static isArray(value) {
    return _.isArray(value);
  }

  static isEmpty(value) {
    return Util.isImmutable(value) ? value.isEmpty() : _.isEmpty(value);
  }

  static isEqual(valueA, valueB) {
    return (Util.isImmutable(valueA) && Util.isImmutable(valueB)) ? Immutable.is(valueA, valueB) : equal(valueA, valueB);
  }

  static isFunction(value) {
    return _.isFunction(value);
  }

  static isImmutable(value) {
    return Iterable.isIterable(value);
  }

  static isObject(value) {
    return Util.isImmutable(value) ? Immutable.Map.isMap(value) : _.isObject(value);
  }

  static isString(value) {
    return _.isString(value);
  }

  static isUndefined(value) {
    return _.isUndefined(value);
  }

  static keys(value) {
    return Util.isImmutable(value) ? value.keySeq() : _.keys(value);
  }

  static map(value, mapper) {
    return Util.isImmutable(value) ? value.map(mapper) : _.map(value, mapper);
  }

  static merge() {
    const args = Array.prototype.slice.call(arguments);
    return _.merge.apply(null, args);
  }

  static reduce(value, reducer, reduction) {
    return Util.isImmutable(value) ? value.reduce(reducer, reduction) : _.reduce(value, reducer, reduction);
  }

  static slice(value, begin, end) {
    return Util.isImmutable(value) ? value.slice(begin, end) : _.slice(value, begin, end);
  }

  static toMap(value) {
    return Immutable.Map.isMap(value) ? value : Immutable.Map(value);
  }
}
